// PJ-3 / B1 — Catálogo VERSIONADO de las 24 posiciones de campo (clave estable
// EN + etiqueta ES + coordenadas en el campo). Mismo archivo en admin y app.
// La posición se guarda en formal_evaluations.position_primary/secondary (clave
// EN); la CHECK de la migración 137 debe contener exactamente estas 24 claves.
//
// Coordenadas (0-100 cada eje) sobre un campo VERTICAL:
//   x: 0 = izquierda, 100 = derecha.
//   y: 0 = arriba (ataque, portería rival), 100 = abajo (portería propia, GK).
// Sirven para pintar el punto del jugador (FieldPitch en web/app + SVG del PDF).

export interface FieldPosition {
  key: string; // clave estable EN (la que se persiste)
  label: string; // etiqueta ES (UI)
  abbr: string; // EN corta para el punto en el campo
  x: number; // 0-100 (izq→der)
  y: number; // 0-100 (ataque→portería propia)
}

// Orden de atrás (GK) hacia delante (CF): así se lee natural en el selector.
export const FIELD_POSITIONS: FieldPosition[] = [
  { key: 'GK', label: 'Portero', abbr: 'GK', x: 50, y: 94 },
  { key: 'SW', label: 'Líbero', abbr: 'SW', x: 50, y: 86 },
  { key: 'RB', label: 'Lateral derecho', abbr: 'RB', x: 82, y: 76 },
  { key: 'RCB', label: 'Defensa central derecho', abbr: 'RCB', x: 63, y: 80 },
  { key: 'CB', label: 'Defensa central', abbr: 'CB', x: 50, y: 82 },
  { key: 'LCB', label: 'Defensa central izquierdo', abbr: 'LCB', x: 37, y: 80 },
  { key: 'LB', label: 'Lateral izquierdo', abbr: 'LB', x: 18, y: 76 },
  { key: 'RWB', label: 'Carrilero derecho', abbr: 'RWB', x: 88, y: 64 },
  { key: 'LWB', label: 'Carrilero izquierdo', abbr: 'LWB', x: 12, y: 64 },
  { key: 'CDM', label: 'Mediocentro defensivo', abbr: 'CDM', x: 50, y: 64 },
  { key: 'RDM', label: 'Mediocentro defensivo derecho', abbr: 'RDM', x: 63, y: 63 },
  { key: 'LDM', label: 'Mediocentro defensivo izquierdo', abbr: 'LDM', x: 37, y: 63 },
  { key: 'RCM', label: 'Mediocentro derecho', abbr: 'RCM', x: 65, y: 48 },
  { key: 'CM', label: 'Mediocentro', abbr: 'CM', x: 50, y: 48 },
  { key: 'LCM', label: 'Mediocentro izquierdo', abbr: 'LCM', x: 35, y: 48 },
  { key: 'RM', label: 'Medio derecho', abbr: 'RM', x: 86, y: 47 },
  { key: 'LM', label: 'Medio izquierdo', abbr: 'LM', x: 14, y: 47 },
  { key: 'CAM', label: 'Mediapunta', abbr: 'CAM', x: 50, y: 33 },
  { key: 'RW', label: 'Extremo derecho', abbr: 'RW', x: 85, y: 25 },
  { key: 'LW', label: 'Extremo izquierdo', abbr: 'LW', x: 15, y: 25 },
  { key: 'RF', label: 'Interior derecho', abbr: 'RF', x: 65, y: 22 },
  { key: 'LF', label: 'Interior izquierdo', abbr: 'LF', x: 35, y: 22 },
  { key: 'SS', label: 'Segundo delantero', abbr: 'SS', x: 50, y: 22 },
  { key: 'CF', label: 'Delantero centro', abbr: 'CF', x: 50, y: 11 },
];

export const FIELD_POSITION_KEYS: string[] = FIELD_POSITIONS.map((p) => p.key);

const BY_KEY: Record<string, FieldPosition> = Object.fromEntries(
  FIELD_POSITIONS.map((p) => [p.key, p])
);

export function fieldPositionByKey(key: string | null | undefined): FieldPosition | null {
  if (!key) return null;
  return BY_KEY[key] ?? null;
}

// Etiqueta ES para una clave (UI/cabecera). null si no hay clave o es desconocida.
export function fieldPositionLabel(key: string | null | undefined): string | null {
  return fieldPositionByKey(key)?.label ?? null;
}
